import * as Sentry from "@sentry/nextjs";
// import { logRocketIdentifyUser } from "analytics/logrocketAnalytics";
import yieldToMain from "util/lodash/yieldToMain";
import { refreshAuth } from "../../api/auth/refreshAuth";
import { IUserSessionUI } from "../../interfaces/session/user-session-v3";
import { isNewsLetterSubscriptionNeededHandler } from "./isNewsLetterSubscriptionNeededHandler";
import { refreshState } from "./refreshState";
import { refreshSucess } from "./refreshSucess";
import { setBusinessInfo } from "./setBusinessInfo";
import { setExpConfigurations } from "./setExpConfigurations";

/**
 * called on first load and every 60 * 1000 * 10 ms then
 */
export function refresh(callback: any = null) {
  return (dispatch: any) => {
    refreshAuth() // user-session-v3
      .then((data: IUserSessionUI) => {
        dispatch(refreshSucess({ ...data.transientStateResponse }));
        dispatch(setExpConfigurations(data.expConfigurations || []));
        dispatch(refreshState(data));
        // logRocketIdentifyUser(data.customerBrowserId);
        if (window.clarity) {
          window.clarity("set", "userId", data.customerBrowserId);
        }
        dispatch(setBusinessInfo({
          businessCustomer: data.businessCustomer,
          associatedWarehouse: data.associatedWarehouse,
        }));
        yieldToMain().then(() => {
          Sentry.setUser({ id: data.customerBrowserId });
        });
        yieldToMain()
          .then(() => {
            dispatch(isNewsLetterSubscriptionNeededHandler());
          });
        if (callback) {
          callback(data);
        }
      })
      .catch((err: any) => console.log(err));
  };
}
